import commonENGB from "@assets/translations/en-GB/common.json";
import titlesENGB from "@assets/translations/en-GB/titles.json";
import subNavigationENGB from "@assets/translations/en-GB/subNavigation.json";
import loginPageENGB from "@assets/translations/en-GB/loginPage.json";
import dashboardENGB from "@assets/translations/en-GB/dashboard.json";
import transactionsENGB from "@assets/translations/en-GB/transactions.json";
import payoutsENGB from "@assets/translations/en-GB/payouts.json";
import purchasesENGB from "@assets/translations/en-GB/purchases.json";
import supportENGB from "@assets/translations/en-GB/support.json";
import tabsENGB from "@assets/translations/en-GB/tabs.json";
import paginationENGB from "@assets/translations/en-GB/pagination.json";
import accountENGB from "@assets/translations/en-GB/account.json";
import storeENGB from "@assets/translations/en-GB/store.json";
import paymentLinksENGB from "@assets/translations/en-GB/paymentLinks.json";

import commonFRFR from "@assets/translations/fr-FR/common.json";
import titlesFRFR from "@assets/translations/fr-FR/titles.json";
import subNavigationFRFR from "@assets/translations/fr-FR/subNavigation.json";
import loginPageFRFR from "@assets/translations/fr-FR/loginPage.json";
import dashboardFRFR from "@assets/translations/fr-FR/dashboard.json";
import transactionsFRFR from "@assets/translations/fr-FR/transactions.json";
import payoutsFRFR from "@assets/translations/fr-FR/payouts.json";
import purchasesFRFR from "@assets/translations/fr-FR/purchases.json";
import supportFRFR from "@assets/translations/fr-FR/support.json";
import tabsFRFR from "@assets/translations/fr-FR/tabs.json";
import paginationFRFR from "@assets/translations/fr-FR/pagination.json";
import accountFRFR from "@assets/translations/fr-FR/account.json";
import storeFRFR from "@assets/translations/fr-FR/store.json";
import paymentLinksFRFR from "@assets/translations/fr-FR/paymentLinks.json";

import commonNLNL from "@assets/translations/nl-NL/common.json";
import titlesNLNL from "@assets/translations/nl-NL/titles.json";
import subNavigationNLNL from "@assets/translations/nl-NL/subNavigation.json";
import loginPageNLNL from "@assets/translations/nl-NL/loginPage.json";
import dashboardNLNL from "@assets/translations/nl-NL/dashboard.json";
import transactionsNLNL from "@assets/translations/nl-NL/transactions.json";
import payoutsNLNL from "@assets/translations/nl-NL/payouts.json";
import purchasesNLNL from "@assets/translations/nl-NL/purchases.json";
import supportNLNL from "@assets/translations/nl-NL/support.json";
import tabsNLNL from "@assets/translations/nl-NL/tabs.json";
import paginationNLNL from "@assets/translations/nl-NL/pagination.json";
import accountNLNL from "@assets/translations/nl-NL/account.json";
import storeNLNL from "@assets/translations/nl-NL/store.json";
import paymentLinksNLNL from "@assets/translations/nl-NL/paymentLinks.json";

import commonDEDE from "@assets/translations/de-DE/common.json";
import titlesDEDE from "@assets/translations/de-DE/titles.json";
import subNavigationDEDE from "@assets/translations/de-DE/subNavigation.json";
import loginPageDEDE from "@assets/translations/de-DE/loginPage.json";
import dashboardDEDE from "@assets/translations/de-DE/dashboard.json";
import transactionsDEDE from "@assets/translations/de-DE/transactions.json";
import payoutsDEDE from "@assets/translations/de-DE/payouts.json";
import purchasesDEDE from "@assets/translations/de-DE/purchases.json";
import supportDEDE from "@assets/translations/de-DE/support.json";
import tabsDEDE from "@assets/translations/de-DE/tabs.json";
import paginationDEDE from "@assets/translations/de-DE/pagination.json";
import accountDEDE from "@assets/translations/de-DE/account.json";
import storeDEDE from "@assets/translations/de-DE/store.json";
import paymentLinksDEDE from "@assets/translations/de-DE/paymentLinks.json";

export const resources = {
  "en-GB": {
    common: commonENGB,
    titles: titlesENGB,
    subNavigation: subNavigationENGB,
    loginPage: loginPageENGB,
    dashboard: dashboardENGB,
    transactions: transactionsENGB,
    payouts: payoutsENGB,
    purchases: purchasesENGB,
    support: supportENGB,
    tabs: tabsENGB,
    pagination: paginationENGB,
    account: accountENGB,
    store: storeENGB,
    paymentLinks: paymentLinksENGB,
  },
  "fr-FR": {
    common: commonFRFR,
    titles: titlesFRFR,
    subNavigation: subNavigationFRFR,
    loginPage: loginPageFRFR,
    dashboard: dashboardFRFR,
    transactions: transactionsFRFR,
    payouts: payoutsFRFR,
    purchases: purchasesFRFR,
    support: supportFRFR,
    tabs: tabsFRFR,
    pagination: paginationFRFR,
    account: accountFRFR,
    store: storeFRFR,
    paymentLinks: paymentLinksFRFR,
  },
  "nl-NL": {
    common: commonNLNL,
    titles: titlesNLNL,
    subNavigation: subNavigationNLNL,
    loginPage: loginPageNLNL,
    dashboard: dashboardNLNL,
    transactions: transactionsNLNL,
    payouts: payoutsNLNL,
    purchases: purchasesNLNL,
    support: supportNLNL,
    tabs: tabsNLNL,
    pagination: paginationNLNL,
    account: accountNLNL,
    store: storeNLNL,
    paymentLinks: paymentLinksNLNL,
  },
  "de-DE": {
    common: commonDEDE,
    titles: titlesDEDE,
    subNavigation: subNavigationDEDE,
    loginPage: loginPageDEDE,
    dashboard: dashboardDEDE,
    transactions: transactionsDEDE,
    payouts: payoutsDEDE,
    purchases: purchasesDEDE,
    support: supportDEDE,
    tabs: tabsDEDE,
    pagination: paginationDEDE,
    account: accountDEDE,
    store: storeDEDE,
    paymentLinks: paymentLinksDEDE,
  },
};
